<div class="file-input-wrapper">
  <div
    class="upload-container"
    (click)="!disabled && input.click()"
    [style.cursor]="disabled ? 'not-allowed' : 'pointer'"
    appDnd
    (fileDropped)="handleFileDrop($event)"
    [class.disabled]="disabled">
    <ng-content></ng-content>
  </div>
  <input
    type="file"
    hidden
    #input
    [accept]="accept"
    (change)="handleInputChange($event)"
    [attr.id]="controlId ?? generatedRandomId"
    [multiple]="multiple"
    [name]="inputName" />
</div>
